<template>
  <div class="progress">
    <div
      v-if="progress !== undefined"
      :aria-valuenow="progress"
      aria-valuemin="0"
      aria-valuemax="100"
      :style="{ width: progress + '%' }"
      class="progress__now"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  /**
   * Reading progress in percent. Without it, only show an empty bar.
   */
  progress?: number
}>()
</script>
